import React from 'react';
import PropTypes from 'prop-types';
import { SelectField } from 'material-ui';
import { MenuItem } from 'material-ui/IconMenu';
import translate from 'components/hoc/translate';

const BooleanSelectField = ({ floatingLabelText, id, name, onChange, onBlur, translate, value }) => {

    const handleChange = (event, index, value) => {
        event.persist();

        event.target.name = event.target.id || name;
        event.target.value = value;

        onChange(event, index, value);
    };

    return (
        <SelectField
            id={ id || name }
            floatingLabelText={ floatingLabelText }
            onChange={ handleChange }
            onBlur={ onBlur }
            value={ value }
        >
            <MenuItem primaryText={ translate('actions.yes') } value={ true } />
            <MenuItem primaryText={ translate('actions.no') } value={ false } />
        </SelectField>
    );
};

BooleanSelectField.propTypes = {
    floatingLabelText: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func,
    value: React.PropTypes.bool,
};

export default translate(BooleanSelectField);



// WEBPACK FOOTER //
// ./src/components/input/SelectField/BooleanSelectField.js